// Notification.tsx
import React from 'react';

import { type MantineTheme, type DefaultMantineColor } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { IconInfoCircle, IconCheck, IconX } from '@tabler/icons-react';
import './Notification.css';

type MessageType = 'info' | 'success' | 'error';

export function showMessage(tipo: MessageType, title: string, message: string) {
  try {
    const configs: Record<MessageType, { color: DefaultMantineColor; icon: React.ReactNode }> = {
      info: { color: 'blue', icon: <IconInfoCircle size={20} /> },
      success: { color: 'green', icon: <IconCheck size={20} /> },
      error: { color: 'red', icon: <IconX size={20} /> },
    };

    const config = configs[tipo] ?? configs.info;

    showNotification({
      title,
      message,
      color: config.color,
      icon: config.icon,
      withCloseButton: true,
      position: 'top-center',
      classNames: { closeButton: 'notification-close-button' },
      styles: (theme: MantineTheme) => {
        const bgMap: Record<MessageType, readonly string[]> = {
          info: theme.colors.blue,
          success: theme.colors.green,
          error: theme.colors.red,
        };
        const bgColor = bgMap[tipo] ?? theme.colors.blue;

        return {
          root: {
            backgroundColor: bgColor[6],
            padding: theme.spacing.md,
            boxShadow: theme.shadows.xl,
            borderRadius: theme.radius.md,
            border: `1px solid ${theme.white}`,
          },
          title: {
            color: theme.white,
            fontWeight: 700,
            textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
          },
          description: {
            color: theme.white,
            fontWeight: 500,
          },
        };
      },
    });
  } catch (error) {
    console.error('Error showing notification:', error);
  }
}
